{
  "unit": {
    "box": "box | boxes",
    "bundle": "bundle | bundles",
    "bus": "bus | buses",
    "can": "can | cans",
    "gram": "gram | grams",
    "kilogram": "kilogram | kilograms",
    "overbox": "overbox | overboxes",
    "pallet": "pallet | pallets",
    "piece": "piece | pieces",
    "pouch": "pouch | pouches",
    "roll": "roll | rolls",
    "set": "set | sets",
    "tube": "tube | tubes",
    "unknown": ""
  },
  "error": {
    "request": {
      "generic": "Error while calling the API."
    }
  }
}
